import type { RecordSourceSelectorProxy } from 'relay-runtime';
import RelayDataID from '@atlassian/relay-data-id';
import { createRouterSelector } from '@atlassian/react-resource-router';
import { getProjectIdOrKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { NAVIGATION_ITEMS_PAGE_SIZE } from '@atlassian/jira-navigation-apps-resources/src/constants.tsx';

export const useProjectIdOrKey: () => string | undefined = createRouterSelector((state) =>
	getProjectIdOrKey(state.match, state.query),
);

export const getConnection = (store: RecordSourceSelectorProxy, containerNavigationId: string) => {
	const dataId = RelayDataID({ id: containerNavigationId }, 'JiraContainerNavigation');
	return (
		dataId &&
		store.get(dataId)?.getLinkedRecord('navigationItems', { first: NAVIGATION_ITEMS_PAGE_SIZE })
	);
};
export const getStoreEdges = (store: RecordSourceSelectorProxy, containerNavigationId: string) => {
	const connection = getConnection(store, containerNavigationId);
	if (!connection) return undefined;

	return connection.getLinkedRecords('edges');
};

export const getAnalyticsTabOrder = (
	store: RecordSourceSelectorProxy,
	containerNavigationId: string,
) => {
	const edges = getStoreEdges(store, containerNavigationId);
	if (!edges) return [];

	return edges.map((edge) => {
		const node = edge?.getLinkedRecord('node');
		const tabId = node?.getValue('appId');

		return {
			itemType: String(node?.getValue('typeKey')).toLowerCase(),
			itemId: tabId ? String(tabId) : undefined,
			// relay will have already updated the changed item, exclude the new default to restore the original values
			defaultTab: Boolean(node?.getValue('isDefault')),
		};
	});
};
